/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Gameawards_Subtitle1Inputs */

const id_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game yang diumumkan atau dinominasikan di The Game Awards yang hadir di Epic Games Store`)
};

const ms_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan diumumkan atau dicalonkan di The Game Awards yang akan datang ke Epic Games Store`)
};

const da_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil annonceret eller nomineret ved The Game Awards der kommer til Epic Games Store`)
};

const de_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei The Game Awards angekündigte oder nominierte Spiele, die in den Epic Games Store kommen`)
};

const en_us2_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games announced or nominated at The Game Awards coming to Epic Games Store`)
};

const es_es2_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos anunciados o nominados en The Game Awards que llegan a la Epic Games Store`)
};

const es_mx2_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos anunciados o nominados en The Game Awards que llegan a la Epic Games Store`)
};

const fil_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga larong inanunsyo o hinirang sa The Game Awards na darating sa Epic Games Store`)
};

const fr_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeux annoncés ou nommés aux Game Awards arrivant sur l'Epic Games Store`)
};

const it_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giochi annunciati o nominati ai The Game Awards in arrivo sull'Epic Games Store`)
};

const hu_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A The Game Awards-on bejelentett vagy jelölt játékok, amelyek érkeznek az Epic Games Store-ba`)
};

const nl_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Games aangekondigd of genomineerd bij The Game Awards die naar de Epic Games Store komen`)
};

const no_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill annonsert eller nominert på The Game Awards som kommer til Epic Games Store`)
};

const pl_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gry ogłoszone lub nominowane podczas The Game Awards trafiające do Epic Games Store`)
};

const pt_br2_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos anunciados ou indicados em The Game Awards chegando em Epic Games Store`)
};

const pt_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos anunciados ou nomeados nos The Game Awards a chegar à Epic Games Store`)
};

const ro_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jocuri anunțate sau nominalizate la The Game Awards care ajung pe Epic Games Store`)
};

const fi_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards -tapahtumassa ilmoitetut tai ehdokkaat pelit tulossa Epic Games Storeen`)
};

const sv_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spel som tillkännages eller nomineras på The Game Awards som kommer till Epic Games Store`)
};

const vi_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các game được công bố hoặc đề cử tại The Game Awards sắp có mặt trên Epic Games Store`)
};

const tr_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards'ta duyurulan veya aday gösterilen ve Epic Games Store'a gelecek oyunlar`)
};

const cs_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hry oznámené nebo nominované na The Game Awards přicházející na Epic Games Store`)
};

const bg_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игри, обявени или номинирани на The Game Awards, които идват в Epic Games Store`)
};

const ru_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игры, анонсированные или номинированные на The Game Awards, выходящие в Epic Games Store`)
};

const uk_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ігри, анонсовані або номіновані на The Game Awards, що з'являться в Epic Games Store`)
};

const ar_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الألعاب المعلنة أو المرشحة في The Game Awards القادمة إلى Epic Games Store`)
};

const hi_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`द गेम अवार्ड्स में घोषित गेम जो Epic Games Store पर आ रहे हैं`)
};

const th_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมที่ประกาศหรือได้รับการเสนอชื่อใน The Game Awards ที่จะมาใน Epic Games Store`)
};

const ja_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards で発表またはノミネートされ、Epic Games Store に登場するゲーム`)
};

const zh_cn2_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 公布或提名、即将登陆 Epic Games Store 的游戏`)
};

const zh_hant1_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards 公布或提名、即將登陸 Epic Games Store 的遊戲`)
};

const ko_misc_gameawards_subtitle1 = /** @type {(inputs: Misc_Gameawards_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Game Awards에서 발표되거나 후보에 오른 Epic Games Store 출시 예정 게임`)
};

/**
* | output |
* | --- |
* | "Games announced or nominated at The Game Awards coming to Epic Games Store" |
*
* @param {Misc_Gameawards_Subtitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_gameawards_subtitle1 = /** @type {((inputs?: Misc_Gameawards_Subtitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Gameawards_Subtitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_gameawards_subtitle1(inputs)
	if (locale === "ms") return ms_misc_gameawards_subtitle1(inputs)
	if (locale === "da") return da_misc_gameawards_subtitle1(inputs)
	if (locale === "de") return de_misc_gameawards_subtitle1(inputs)
	if (locale === "en-US") return en_us2_misc_gameawards_subtitle1(inputs)
	if (locale === "es-ES") return es_es2_misc_gameawards_subtitle1(inputs)
	if (locale === "es-MX") return es_mx2_misc_gameawards_subtitle1(inputs)
	if (locale === "fil") return fil_misc_gameawards_subtitle1(inputs)
	if (locale === "fr") return fr_misc_gameawards_subtitle1(inputs)
	if (locale === "it") return it_misc_gameawards_subtitle1(inputs)
	if (locale === "hu") return hu_misc_gameawards_subtitle1(inputs)
	if (locale === "nl") return nl_misc_gameawards_subtitle1(inputs)
	if (locale === "no") return no_misc_gameawards_subtitle1(inputs)
	if (locale === "pl") return pl_misc_gameawards_subtitle1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_gameawards_subtitle1(inputs)
	if (locale === "pt") return pt_misc_gameawards_subtitle1(inputs)
	if (locale === "ro") return ro_misc_gameawards_subtitle1(inputs)
	if (locale === "fi") return fi_misc_gameawards_subtitle1(inputs)
	if (locale === "sv") return sv_misc_gameawards_subtitle1(inputs)
	if (locale === "vi") return vi_misc_gameawards_subtitle1(inputs)
	if (locale === "tr") return tr_misc_gameawards_subtitle1(inputs)
	if (locale === "cs") return cs_misc_gameawards_subtitle1(inputs)
	if (locale === "bg") return bg_misc_gameawards_subtitle1(inputs)
	if (locale === "ru") return ru_misc_gameawards_subtitle1(inputs)
	if (locale === "uk") return uk_misc_gameawards_subtitle1(inputs)
	if (locale === "ar") return ar_misc_gameawards_subtitle1(inputs)
	if (locale === "hi") return hi_misc_gameawards_subtitle1(inputs)
	if (locale === "th") return th_misc_gameawards_subtitle1(inputs)
	if (locale === "ja") return ja_misc_gameawards_subtitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_gameawards_subtitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_gameawards_subtitle1(inputs)
	return ko_misc_gameawards_subtitle1(inputs)
});
export { misc_gameawards_subtitle1 as "misc.gameAwards.subtitle" }